import sectionCardMediaSlider02Css from '../css-snippets/section-card-media-slider-02';

const html = `
<style>${sectionCardMediaSlider02Css}</style>
<div
  id="card-container-unique-id"
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="true"
  data-bottom-padding="true"
  data-pagination-active-color="#000000"
  data-pagination-inactive-color="#cccccc"
  style="
    background-color: rgb(255, 255, 255);
    --pagination-active-color: #000000;
    --pagination-inactive-color: #cccccc;
  "
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="true"
    data-background="#FFFFFF"
    style="background-color: transparent"
  >
    <div class="wrap-card container">
      <div
        data-attribute="card-header"
        data-show="true"
        class="card-header"
        style="display: block"
      >
        <h2 style="text-align: center">
          <strong>Helping Drivers Everywhere</strong>
        </h2>
        <p style="text-align: center">
          Airmoto ads have been featured on Fox News and Good Morning America! All across the world, <br /> Airmoto is making waves and winning hearts. See what all the buzz is about and why everyone's raving!
        </p>
      </div>
      <div class="swiper swiper-video-unique-id">
        <div
          data-attribute="list-item"
          class="swiper-wrapper"
          data-bg-play-video="#d4c4a8"
          data-color-play-video="#FFFFFF"
          data-pagination-active-color="#000000"
          data-pagination-inactive-color="#cccccc"
        >
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source
                  data-attribute="card-video"
                  src="https://deals.getairmoto.com/assets/airmoto/video/foxnews.webm"
                  type="video/mp4"
                />
              </video>
              <div class="volume">
                <span class="volume-icon" style="display: none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2"
                  >
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                    />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off"
                  >
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11"
                    />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source
                  data-attribute="card-video"
                  src="https://deals.getairmoto.com/assets/airmoto/video/gma.webm"
                  type="video/mp4"
                />
              </video>
              <div class="volume">
                <span class="volume-icon" style="display: none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2"
                  >
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                    />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off"
                  >
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11"
                    />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>

`;
export default html;
